import React, { type FC } from 'react';
import { Select, Space, Text, Textarea } from '@g2u/ui-kit';
import { observer } from 'mobx-react-lite';
import { type FormInstance } from 'antd';
import cx from 'classnames';

import { type WithOptionalDataTest } from 'types';
import { useServiceTypes } from '../hooks';
import { useText } from 'helpers/hooks/useText';
import { BookingStore } from 'store';
import { Section } from 'components';
import styles from '../location.module.scss';

export namespace JobDetails {
  export type Props = {
    customerId?: number;
    onChange?: () => void;
    form: FormInstance;
  } & WithOptionalDataTest;

  export const $: FC<Props> = observer((props) => {
    const { customerId, onChange } = props;
    const { productSelection, customer } = BookingStore;
    const { getText } = useText();
    const { serviceTypes, isServiceTypesLoading } = useServiceTypes(customer?.ID || customerId);

    // Warranty Service Temporary disabled
    // All commented sections are related to the Warranty Service Functionlaity

    // const isWarrantyService = [JobServiceType.TechnicianWarranty, JobServiceType.CompanyWarranty].includes(
    //   form.getFieldValue('serviceType'),
    // );

    // get warranty reasons
    // const {
    //   mutate: getReasons,
    //   data: warrantyReasons,
    //   isLoading: isWarrantyReasonsLoading,
    // } = useMutation(getWarrantyReasons, {
    //   onError: (data: JsonDataItem) => {
    //     Toast.show({ description: parseErrors(data).join(', '), type: Toast.Type.Error });
    //   },
    // });

    // get previous jobs
    // const {
    //   mutate: getPreviousJobs,
    //   data: previousJobs,
    //   isLoading: isPrevJobsLoading,
    // } = useMutation(getJobSearch, {
    //   onError: (data: JsonDataItem) => {
    //     Toast.show({ description: parseErrors(data).join(', '), type: Toast.Type.Error });
    //   },
    // });

    // useEffect(() => {
    //   if (isWarrantyService) {
    //     getReasons();
    //     getPreviousJobs({ searchParam: 'customer_id', page: 1, searchValue: customer?.ID, recordsPerPage: 100 });
    //   }
    // }, [isWarrantyService]);

    // const formatJobsToOptions = (jobs: JsonData) => {
    //   return jobs?.map((service: JsonDataItem) => {
    //     return {
    //       label: (
    //         <>
    //           {service.job.ID} -{' '}
    //           <Text.$ type="secondary">{format(new Date(service.job.appointment), 'dd/MM/yyyy')}</Text.$>
    //         </>
    //       ),
    //       value: service.job.ID.toString(),
    //     };
    //   });
    // };

    // const formatReasonsToOptions = (reasons: JsonData) => {
    //   return reasons?.map((reason: JsonDataItem) => {
    //     return {
    //       label: <>{reason.reason}</>,
    //       value: reason.ID.toString(),
    //       disabled: reason.active !== Condition.Yes,
    //     };
    //   });
    // };

    return (
      <Section.$ title="Job Details">
        <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Middle}>
          <Text.$ className="script-box" mark>
            {getText('booking.location.offerAssistance')}
          </Text.$>
          <Space.$ direction={Space.Direction.Horizontal} size={Space.Size.Middle} fullWidth>
            <Select.$
              required
              dataTestId="service-type-select"
              initialValue={productSelection?.serviceType}
              label="Service Type: "
              name="serviceType"
              className={cx(
                styles.location__formItem,
                styles.location__formItem_horizontal,
                styles.location__formItem_columned,
              )}
              loading={isServiceTypesLoading}
              options={serviceTypes}
              rules={[{ required: true }]}
              onChange={onChange}
            />
          </Space.$>

          {/* {(isWarrantyReasonsLoading || isPrevJobsLoading) && (
            <Space.$ justify={Space.Justify.Center} style={{ width: '300px', marginBottom: '5px' }}>
              <Spin />
            </Space.$>
          )} */}

          {/* {isWarrantyService && !isWarrantyReasonsLoading && !isPrevJobsLoading && (
            <>
              <Select.$
                required
                dataTestId="job-id-select"
                initialValue={productSelection?.jobId || formatJobsToOptions(previousJobs?.data)?.[0]?.value}
                label="Original Job ID: "
                name="jobId"
                className={cx(
                  styles.location__formItem,
                  styles.location__formItem_horizontal,
                  styles.location__formItem_columned,
                )}
                options={formatJobsToOptions(previousJobs?.data)}
                rules={[{ required: true }]}
              />
              <Select.$
                required
                dataTestId="warranty-reason-select"
                initialValue={productSelection?.warrantyReason}
                label="Warranty Reason: "
                name="warrantyReason"
                className={cx(
                  styles.location__formItem,
                  styles.location__formItem_horizontal,
                  styles.location__formItem_columned,
                )}
                options={formatReasonsToOptions(warrantyReasons)}
                rules={[{ required: true }]}
              />
            </>
          )} */}

          <Textarea.$
            name="description"
            placeholder="Please collect a good level of problem details here."
            initialValue={productSelection?.description}
            className={cx(
              styles.location__formItem,
              styles.location__formItem_horizontal,
              styles.location__formItem_columned,
            )}
            required
            label={'Prob Description: '}
            rules={[{ required: true, message: 'Please enter a description' }]}
          />
        </Space.$>
      </Section.$>
    );
  });
}
